<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsLine',
  
})
</script>
<template>
  <v-chart
    class="tlbs-line"
    :option="option"
    :autoresize="true"
  />
</template>

<script lang="ts" setup name="TlbsLine">
import * as echarts from 'echarts/core';
import VChart from 'vue-echarts';
import { LegendComponentOption, TooltipComponentOption } from 'echarts/components';
import { LineSeriesOption } from 'echarts/charts';

type EChartsOption = echarts.ComposeOption<
TooltipComponentOption | LegendComponentOption | LineSeriesOption
>;

interface DataItem {
  value: number;
  name: string;
  itemStyle: {
    color: string;
  }
}

interface Props {
  data: DataItem[];
  type: string,
  color?: string | string[],
  linearColor?: string | string[],
  lineStyle: LooseObject;
  label: LooseObject;
  smooth: boolean;
  legend: EChartsOption['legend'];
  xAxis: LooseObject,
  yAxis: LooseObject,
  seriesProperty?: LooseObject;
  optionConfig?: LooseObject,
}

const props = withDefaults(defineProps<Props>(), {
  data: () => [],
  smooth: false,
  color: () => ['#ED8139', '#31C8C8', '#3479ED'],
  linearColor: () => [],
  legend: () => ({}),
  lineStyle: () => ({}),
  label: () => ({}),
  xAxis: () => ({}),
  yAxis: () => ({}),
  optionConfig: () => ({}),
  seriesProperty: () => ({}),
  type: 'column',
});

const getOption = (): EChartsOption => {
  let nameArr: never[] | Set<any> = [];
  const categoryArr: string[] = [];
  const valueArr: unknown[][] = [];
  props.data.forEach((data) => {
    categoryArr.push(data.name);
    nameArr = new Set([...nameArr, ...Object.keys(data.value)]);
    Object.values(data.value).forEach((item, index) => {
      valueArr[index] = valueArr[index] || [];
      valueArr[index].push(item);
    });
  });
  // if (props.lineStyle) {
  //   series.lineStyle = props.lineStyle;
  // }
  // if (props.label) {
  //   series.label = props.label;
  // }
  const series = Array.from(nameArr).map((name, index) => ({
    data: valueArr[index],
    type: 'line',
    lineStyle: props.lineStyle || undefined,
    label: props.label || undefined,
    smooth: props.smooth,
    areaStyle: {
      opacity: 0.4,
      color: new echarts.graphic.LinearGradient(1, 1, 1, 0, [
        {
          offset: 0,
          color: props.linearColor[index] || 'rgba(0, 0, 0, 0)',
        },
        {
          offset: 1,
          color: props.color[index],
        },
      ]),
    },
    ...props.seriesProperty[name] || {},
    name,
  }));
  // console.log('series', series);
  const valueData = {
    type: 'value',
    // axisLabel: {
    //   textStyle: props.textStyle,
    // },
  };
  const nameData = {
    type: 'category',
    data: Array.from(categoryArr),
    // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    boundaryGap: false,
    // axisLabel: {
    //   textStyle: props.textStyle,
    // },
  };
  const xAxis = props.type === 'column' ? valueData : nameData;
  const yAxis = props.type === 'column' ? nameData : valueData;
  const option = {
    tooltip: {
      show: true,
      trigger: 'axis',
    },
    color: props.color,
    xAxis: {
      ...xAxis,
      name: props.xAxis.name,
      axisLabel: {
        show: true,
      },
      ...props.xAxis,
    },
    yAxis: {
      ...yAxis,
      name: props.yAxis.name,
      axisLabel: {
        show: true,
      },
      ...props.yAxis,
    },
    legend: props.legend,
    series,
    ...props.optionConfig,
  };
  console.log(option);
  return option;
};

const option = ref<EChartsOption>(getOption());

watch(props, () => {
  option.value = getOption();
});


</script>
